module.exports = __webpack_public_path__ + "img/privacy-policy-d.fcf51ac.webp";